<template>
    <div v-if="discount && ! dismissed" class="promo-notice">
        <base-notification @hide-user-notification="dismissed = true">
            {{ discount.lead }}<br v-if="discount.duration">
            {{ discount.duration }}
        </base-notification>
    </div>
</template>

<script>
import apiCall from '@/utils/apiCall';
import formatDiscount from '@/utils/formatDiscount';

export default {
    data: () => ({
        coupon: null,
        formProcessing: false,
        dismissed: false,
    }),

    computed: {
        /**
         * Builds the discount notice parts from the resolved coupon.
         *
         * @returns {?{lead: string, duration: ?string}} Notice parts, or null when nothing should show.
         */
        discount() {
            return formatDiscount(this.coupon);
        },
    },

    /**
     * Resolves the inbound-coupon promo (if any) so the notice can render.
     *
     * Reads the `fusebox_promo` cookie set by the SetPromoCookie middleware and
     * asks the public promo-preview endpoint for the discount. Any miss (no
     * cookie, expired/invalid promo, 204, or network error) leaves the notice
     * hidden.
     *
     * @returns {Promise} Promise.
     */
    async mounted() {
        const code = this.$cookies.get('fusebox_promo');

        if (! code) {
            return;
        }

        const { status, data } = await apiCall(
            this,
            'post',
            `${this.$appUrl}/api/billing/promo-preview/${code}`
        );

        if ([200, 201].includes(status) && data?.coupon) {
            this.coupon = data.coupon;
        }
    },
};
</script>

<style scoped lang="scss">
    @use './PromoNotice.scss';
</style>
